import { defineComponent, createElementBlock, openBlock, normalizeClass, unref, createElementVNode } from 'vue';
import { useBlockPositioning } from './basler-components.es357.js';

const _hoisted_1 = { class: "html-block__inner" };
const _hoisted_2 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HtmlBlock",
  props: {
    content: { default: "" },
    cols: { default: 6 },
    colsCentered: { type: Boolean, default: true },
    contentCentered: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const { positioningClassNames } = useBlockPositioning(
      "html-block",
      props.cols,
      props.colsCentered,
      props.contentCentered
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["html-block", unref(positioningClassNames)])
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", {
            innerHTML: props.content
          }, null, 8, _hoisted_2)
        ])
      ], 2);
    };
  }
});

export { _sfc_main as default };
